import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import {
  EXEMPT,
  StatusFormValues,
  parseDecimal,
} from "../config/statusFormConfig";
import { ProgressNode } from "../types";
import { toLocalDateTime } from "./dateTime";

interface SaveCompletionArgs {
  corporateId: string | number;
  userId: string | number;
  nodes: ProgressNode[];
  values: StatusFormValues;
}

interface Hierarchy {
  objectId: number;
  parentId?: number;
  grandparentId?: number;
}

const toHierarchy = (node: ProgressNode): Hierarchy => ({
  objectId: node.id,
  ...(node.parentActivityId != null ? { parentId: node.parentActivityId } : {}),
  ...(node.grandparentActivityId != null
    ? { grandparentId: node.grandparentActivityId }
    : {}),
});

const toScore = (value?: string | null): number | undefined =>
  parseDecimal(value) ?? undefined;

export const saveCompletion = ({
  corporateId,
  userId,
  nodes,
  values,
}: SaveCompletionArgs) => {
  const base = {
    corporateId: Number(corporateId),
    userId: Number(userId),
    reason: values.reason ?? "",
  };

  if (values.newStatus === EXEMPT) {
    return fetcher<any>(ServicesURL.postExempt, MethodType.POST, {
      ...base,
      exemptionDateTime: toLocalDateTime(values.completionDate),
      hierarchies: nodes.map(toHierarchy),
    });
  }

  const completion = {
    ...base,
    completionDateTime: toLocalDateTime(values.completionDate),
  };

  if (nodes.length === 1) {
    return fetcher<any>(ServicesURL.postForceCompletion, MethodType.POST, {
      ...completion,
      ...toHierarchy(nodes[0]),
      score: toScore(values.score),
    });
  }

  return fetcher<any>(ServicesURL.postForceCompletionObjects, MethodType.POST, {
    ...completion,
    hierarchies: nodes.map(toHierarchy),
  });
};
